import React from 'react'

const Footer = () => {
    return (
        <div style={{background:'black',color:'white',textAlign:'center',padding:'5px'}}>
            Copyright &copy; Doctors Portal
        </div>
    )
}

export default Footer
